import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { updateCanvas } from '../../../app/store/slices/canvasSlice';
import { currencyOptions } from '../../../utils/constants/currencyOptions';
import logo from '../../../assets/images/logos/576_Cash Canvas-02.png';

const UpdateCanvas = () => {
  const location = useLocation();
  const canvasId = location.state?.canvasId;

  const [currency, setCurrency] = useState('');
  const [error, setError] = useState('');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading } = useSelector((state) => state.canvas);

  const handleSubmit = async () => {
    if (!currency.trim()) {
      setError('Currency is required.');
      return;
    }

    try {
      const canvasData = {
        id: canvasId,
        currency:  currency 
      };
      await dispatch(updateCanvas(canvasData)).unwrap();

      navigate('/account', {
        state:{canvasId: canvasId, currency: currency },
      });
    } catch (err) {
      setError(err?.message || 'Failed to update canvas');
      console.error(err);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      {/* Logo with better responsive sizing */}
      <div className="fixed top-0 left-0 p-4 z-10">
        <img 
          src={logo} 
          alt="Cash Canvas Logo" 
          className="h-12 sm:h-16 md:h-20 w-auto object-contain"
        />
      </div>

      {/* Main Content */}
      <div className="card-setup w-full mx-auto">  
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="txt-page-heading">Set Your Currency</h1>
          <p className="p-tag-below-heading mt-2 text-gray-600 px-2 sm:px-0">
            Select your preferred currency. This will be used throughout your canvas for financial tracking.
          </p>
        </div>

        {/* Currency Select with improved responsive width */}
        <div className="w-[95%] sm:w-4/5 md:w-3/4 lg:w-2/3 mx-auto">
          <select
            value={currency}
            onChange={(e) => setCurrency(e.target.value)}
            className="input-field"
          >
            <option value="">Select Currency</option>
            {currencyOptions.map((currency) => (
              <option key={currency.code} value={currency.code}>
                {currency.code} - {currency.name} ({currency.symbol})
              </option>
            ))}
          </select>
          {error && (
            <p className="text-sm text-red-600 mt-2">{error}</p>
          )}
        </div>

        {/* Navigation Buttons */}
        <div className="absolute bottom-6 left-0 right-0 flex justify-between px-4 sm:px-6 md:px-8 w-full">
          <button
            onClick={() => navigate(-1)}
            className="btn-back text-sm sm:text-base whitespace-nowrap"
          >
            Back
          </button>
          <button
            onClick={handleSubmit}
            disabled={loading}
            className="btn-continue text-sm sm:text-base whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? (
              <span className="flex items-center gap-2">
                <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
                  <circle 
                    className="opacity-25" 
                    cx="12" 
                    cy="12" 
                    r="10" 
                    stroke="currentColor" 
                    strokeWidth="4"
                  />
                  <path 
                    className="opacity-75" 
                    fill="currentColor" 
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  />
                </svg>
                Updating...
              </span>
            ) : (
              'Continue'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateCanvas;
